export const username = (state: any) => state.user.username;
export const oldPassword = (state: any) => state.user.oldPassword;
export const isAdmin = (state: any) => state.isAdmin;
export const user = (state: any) => state.user;
export const challenge = (state: any) => state.challenge;
